import axios from "axios";
import imageZoom from 'vue-image-zoomer';

export default {
  name: "articlesDetailesSection",
  components:{
    imageZoom
  },
  data() {
    return {
      allArticles: [],
      pageSize: 16,
      currentPage: 1,
      productUser: [],
      picNumber: 0,
      modelDescription: "",
      modelPrice: "",
      modelTitle: "",
      modelImage0: "",
      modelImage1: "",
      modelImage2: "",
      modelImage3: "",
      sortedData: [],
      selectedFilters: [],
      dataToFilter: [],
      FilterAll: "",
      modelDisponible: "",
      quantiteMax: 1,
      quantiteMin: 1,
      btnValue: "",
      selectDetailsSize: "",
      detailsElement: [],
      detailsElementSize: [],
      detailsElementPointure: [],
      detailsElementDimmension: [],
      dimmensionLargeur: 0,
      dimmensionLongueur: 0,
      maxW: 0,
      maxH: 0,
      // sizeProduct:["x","y"],
      model: {
        quantite: 1,
      },
      subId: "",
      colorImg: ""
    };
  },
  async created() {
    this.getElement();
    axios
      .post("https://giftstore-blog.herokuapp.com/api/user/addViewedProduct", {
        userId: window.localStorage.getItem("Giftstore-U"),
        productId: this.$router.history.current.query.id_article,
      })
      .then((response) => {
        console.log(response)
        // this.$toast.open({
        //   message: "Produit supprimé au Panier",
        //   type: "success",
        // this.$store.getters.getUserInfo.viewedProduct =
        //   response.data.user.viewedProduct;
        // });
        console.log("test is ok");
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
    // await this.$loadScript(
    //   "http://ajax.googleapis.com/ajax/libs/jquery/1.10.2/jquery.min.js"
    // );
    // await this.$loadScript("./js/jquery.zoom.js");
    // $(".img-hover").zoom();
  },
  methods: {
    verifImg(img) {
      if (
        img.includes(
          "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/undefined"
        )
      ) {
        return false;
      } else {
        return true;
      }
    },
    numberWithSpaces(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },
    getElement() {
      axios
        .get(
          "https://giftstore-blog.herokuapp.com/api/product/get/" +
            this.$router.history.current.query.id_article
        )
        .then((response) => {
          console.log("articles", response);
          this.detailsElement = response.data.fetchedArticle;
          this.elementDisplay();
        })
        .catch((error) => {
          console.error("There was an error!", error);
        });
    },
    elementDisplay() {
      if (this.detailsElement.typeArticle == "vetements") {
        this.subid = this.detailsElement.vetements[0]._id;
        this.colorImg = this.detailsElement.vetements[0].couleur;
        this.selectDetailsSize = this.detailsElement.vetements[0].tailleEtQuantites[0].taille;
        this.detailsElement.Size = this.detailsElement.vetements[0].tailleEtQuantites;
        this.quantiteMax = this.detailsElement.vetements[0].tailleEtQuantites[0].quantite;
        this.modelImage0 =
          "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          this.detailsElement.vetements[0].image[0];
        this.modelImage1 =
          "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          this.detailsElement.vetements[0].image[0];
        this.modelImage2 =
          "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          this.detailsElement.vetements[0].image[1];
        this.modelImage3 =
          "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          this.detailsElement.vetements[0].image[2];

        if (this.detailsElement.disponibility) {
          if (
            new Date(this.detailsElement.disponibility[0]) > new Date() ||
            this.detailsElement.vetements[0].tailleEtQuantites[0].quantite <= 0
          ) {
            this.modelDisponible = "Précommander";
          } else {
            this.modelDisponible = "Disponible";
          }
        } else if (
          this.detailsElement.vetements[0].tailleEtQuantites[0].quantite > 0
        ) {
          this.modelDisponible = "Disponible";
        }
      } else if (this.detailsElement.typeArticle == "chaussure") {
        this.subid = this.detailsElement.chaussure[0]._id;
        this.colorImg = this.detailsElement.chaussure[0].couleur;
        this.selectDetailsPointure = this.detailsElement.chaussure[0].pointureEtQuantites[0].pointure;
        this.detailsElement.Pointure = this.detailsElement.chaussure[0].pointureEtQuantites;
        this.quantiteMax = this.detailsElement.chaussure[0].pointureEtQuantites[0].quantite;

        this.modelImage0 =
          "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          this.detailsElement.chaussure[0].image[0];
        this.modelImage1 =
          "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          this.detailsElement.chaussure[0].image[0];
        this.modelImage2 =
          "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          this.detailsElement.chaussure[0].image[1];
        this.modelImage3 =
          "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          this.detailsElement.chaussure[0].image[2];

        if (this.detailsElement.disponibility) {
          if (
            new Date(this.detailsElement.disponibility[0]) > new Date() ||
            this.detailsElement.chaussure[0].pointureEtQuantites[0].quantite <=
              0
          ) {
            this.modelDisponible = "Précommander";
          } else {
            this.modelDisponible = "Disponible";
          }
        } else if (
          this.detailsElement.chaussure[0].pointureEtQuantites[0].quantite > 0
        ) {
          this.modelDisponible = "Disponible";
        }
      } else if (this.detailsElement.typeArticle == "tapis") {
        this.subid = this.detailsElement.tapis[0]._id;
        this.colorImg = this.detailsElement.tapis[0].couleur;
        this.detailsElement.Dimmension = this.detailsElement.tapis[0].widthAndHeight;
        this.maxH = this.detailsElement.Dimmension[0].heightMax;
        this.maxW = this.detailsElement.Dimmension[0].widthMax;
        this.selectDetailsPointure = this.detailsElement.tapis[0].widthAndHeight[0].pointure;
        this.detailsElement.Pointure = this.detailsElement.tapis[0].widthAndHeight;
        this.quantiteMax = this.detailsElement.tapis[0].widthAndHeight[0].quantite;

        this.modelImage0 =
          "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          this.detailsElement.tapis[0].image[0];
        this.modelImage1 =
          "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          this.detailsElement.tapis[0].image[0];
        this.modelImage2 =
          "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          this.detailsElement.tapis[0].image[1];
        this.modelImage3 =
          "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          this.detailsElement.tapis[0].image[2];

        if (this.detailsElement.disponibility) {
          if (
            new Date(this.detailsElement.disponibility[0]) > new Date() ||
            this.detailsElement.tapis[0].widthAndHeight[0].quantite <= 0
          ) {
            this.modelDisponible = "Précommander";
          } else {
            this.modelDisponible = "Disponible";
          }
        } else if (
          this.detailsElement.tapis[0].widthAndHeight[0].quantite > 0
        ) {
          this.modelDisponible = "Disponible";
        }
      } else if (this.detailsElement.typeArticle == "autre") {
        this.subid = this.detailsElement.autre[0]._id;
        this.colorImg = this.detailsElement.autre[0].couleur;
        this.selectDetailsPointure = this.detailsElement.autre[0].quantites[0].pointure;
        this.detailsElement.Pointure = this.detailsElement.autre[0].quantites;
        this.quantiteMax = this.detailsElement.autre[0].quantites[0].quantite;

        this.modelImage0 =
          "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          this.detailsElement.autre[0].image[0];
        this.modelImage1 =
          "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          this.detailsElement.autre[0].image[0];
        this.modelImage2 =
          "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          this.detailsElement.autre[0].image[1];
        this.modelImage3 =
          "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          this.detailsElement.autre[0].image[2];

        if (this.detailsElement.disponibility) {
          if (
            new Date(this.detailsElement.disponibility[0]) > new Date() ||
            this.detailsElement.autre[0].quantites[0].quantite <= 0
          ) {
            this.modelDisponible = "Précommander";
          } else {
            this.modelDisponible = "Disponible";
          }
        } else if (this.detailsElement.autre[0].quantites[0].quantite > 0) {
          this.modelDisponible = "Disponible";
        }
      }

      this.modelDescription = this.detailsElement.description;
      this.modelPrice = this.numberWithSpaces(this.detailsElement.productPrice);
      this.modelTitle = this.detailsElement.label;
      this.btnValue = this.detailsElement.orderType;
    },
    getValueDimmension(type) {
      if (type == "1") {
        if (
          this.detailsElement.Dimmension[0].widthMax < this.dimmensionLargeur ||
          this.detailsElement.Dimmension[0].widthMin > this.dimmensionLargeur
        ) {
          // this.$toast.open({
          //   message:
          //     "Largeur maximal est " +
          //     this.detailsElement.Dimmension[0].widthMax,
          //   type: "error",
          //   // position: "top-right",
          //   // all of other options may go here
          // });
        }
      } else {
        if (
          this.detailsElement.Dimmension[0].heightMax <
            this.dimmensionLongueur ||
          this.detailsElement.Dimmension[0].heightMin > this.dimmensionLongueur
        ) {
          // this.$toast.open({
          //   message:
          //     "Longeur maximal est " +
          //     this.detailsElement.Dimmension[0].heightMax,
          //   type: "error",
          //   // position: "top-right",
          //   // all of other options may go here
          // });
        }
      }
    },
    changeDetailProduct(element, index) {
      this.colorImg = element.couleur;
      this.getImage(element.image[0]);
      console.log(index);
      if (this.detailsElement.typeArticle == "vetements") {
        this.detailsElementSize = this.detailsElement.vetements[
          index
        ].tailleEtQuantites;
        this.subId = this.detailsElement.vetements[index]._id;
      } else if (this.detailsElement.typeArticle == "chaussure") {
        this.detailsElementPointure = this.detailsElement.chaussure[
          index
        ].pointureEtQuantites;
        this.subId = this.detailsElement.chaussure[index]._id;
      } else if (this.detailsElement.typeArticle == "tapis") {
        this.detailsElementDimmension = this.detailsElement.tapis[
          index
        ].widthAndHeight;
        this.maxH = this.detailsElementDimmension[0].heightMax;
        this.maxW = this.detailsElementDimmension[0].widthMax;
        if (this.detailsElementDimmension[0].quantite == 0) {
          this.quantiteMax = 0;
          this.quantiteMin = 0;
        } else {
          this.quantiteMax = this.detailsElementDimmension[0].quantite;
        }
        this.subId = this.detailsElement.tapis[index]._id;
      } else if (this.detailsElement.typeArticle == "autre") {
        this.detailsElementDimmension = this.detailsElement.autre[
          index
        ].quantites;
        if (this.detailsElementDimmension[0].quantite == 0) {
          this.quantiteMax = 0;
          this.quantiteMin = 0;
        } else {
          this.quantiteMax = this.detailsElementDimmension[0].quantite;
        }
        this.subId = this.detailsElement.autre[index]._id;
      }
    },
    getImage(img) {
      console.log(this);
      if (
        img.includes(
          "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/"
        )
      ) {
        this.modelImage0 = img;
      } else {
        this.modelImage0 =
          "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          img;
      }
    },
    getSizeChange() {
      this.detailsElementSize.forEach((element) => {
        if (element._id == this.selectDetailsSize) {
          if (element.quantite == 0) {
            this.quantiteMax = 0;
            this.quantiteMin = 0;
          } else {
            console.log("true");
            this.quantiteMax = element.quantite;
          }
          if (element.quantite > 0) {
            this.modelDisponible = "Disponible";
          } else {
            this.modelDisponible = "Précommander";
          }
        } else {
          console.log("false");
        }
      });
    },
    pointureChange(element) {
      console.log(element);
      return element.pointure;
    },
    getpointureChange() {
      this.detailsElementPointure.forEach((element) => {
        console.log(element.quantite);
        if (element._id == this.selectDetailsPointure) {
          if (element.quantite == 0) {
            this.quantiteMax = 0;
            this.quantiteMin = 0;
          } else {
            this.quantiteMax = element.quantite;
          }
          if (element.quantite > 0) {
            this.modelDisponible = "Disponible";
          } else {
            this.modelDisponible = "Précommander";
          }
        } else {
          console.log("false");
        }
      });
    },
    sizeChange(element) {
      console.log(element);
      return element.taille;
    },
    imgColor(img) {
      return (
        "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" + img
      );
    },
    GetProductNumber() {
      //extracting the theme number from local storage
      if (localStorage.getItem("ProductNumber") === null) {
        return 0;
      } else {
        return localStorage.getItem("ProductNumber");
      }
    },
    addedElement() {
      var ProNum = this.GetProductNumber();
      var idElement;
      for (let i = 1; i <= ProNum; i++) {
        idElement = localStorage.getItem("product" + i);
        if (idElement == this.$router.history.current.query.id_article) {
          return false;
        }
      }
      return true;
    },
    addedwhislit(id) {
      // ._id
      console.log(this.$store.getters.getUserInfo.wishList);
      var wishListTab = [];
      if (this.$store.getters.getUserInfo.wishList == "undefined") {
        wishListTab = this.$store.getters.getUserInfo.wishList;
        for (let i = 0; i <= wishListTab.length - 1; i++) {
          console.log("tetetetet", wishListTab[i], id);
          if (wishListTab[i] == id) {
            return false;
          }
        }
        return true;
      } else {
        return true;
      }
    },
    deleteArticle() {
      var TabThemes = [];
      var nb = this.GetProductNumber();
      window.localStorage.removeItem("ProductNumber");
      var idElement;
      for (var k = 1; k <= nb; k++) {
        idElement = JSON.parse(localStorage.getItem("product" + k));
        if (
          idElement.productId != this.$router.history.current.query.id_article
        ) {
          TabThemes.push(JSON.stringify(idElement));
        }
        window.localStorage.removeItem("product" + k);
      }
      for (var j = 1; j <= TabThemes.length; j++) {
        localStorage.setItem("product" + j, TabThemes[j - 1]);
      }
      localStorage.setItem("ProductNumber", TabThemes.length);
      this.$toast.open({
        message: "Produit supprimé au Panier",
        type: "success",
      });
      this.$store.commit("setbasket", TabThemes);
    },
    addArticle() {
      let ProNum = this.GetProductNumber();
      var TabThemes = [];
      ProNum++;
      var product;
      console.log("add panier", this.detailsElement);
      if (this.detailsElement.typeArticle == "vetements") {
        product = {
          image: this.detailsElement.vetements[0].image[0],

          label: this.detailsElement.label,
          productPrice: this.detailsElement.productPrice,
          type: this.detailsElement.typeArticle,
          quantite: parseInt(this.model.quantite),
          taille: this.selectDetailsSize,
          color: this.colorImg,
          productId: this.$router.history.current.query.id_article,
          vetements: {
            _id: this.subid,
          },
        };
      } else if (this.detailsElement.typeArticle == "chaussure") {
        product = {
          image: this.detailsElement.chaussure[0].image[0],

          label: this.detailsElement.label,
          productPrice: this.detailsElement.productPrice,
          type: this.detailsElement.typeArticle,
          quantite: parseInt(this.model.quantite),
          pointure: this.selectDetailsPointure,
          color: this.colorImg,
          productId: this.$router.history.current.query.id_article,
          chaussure: {
            _id: this.subid,
          },
        };
      } else if (this.detailsElement.typeArticle == "tapis") {
        product = {
          image: this.detailsElement.tapis[0].image[0],
          label: this.detailsElement.label,
          productPrice: this.detailsElement.productPrice,
          type: this.detailsElement.typeArticle,
          quantite: parseInt(this.model.quantite),
          widthMax: this.dimmensionLargeur,
          heightMax: this.dimmensionLongueur,
          color: this.colorImg,
          productId: this.$router.history.current.query.id_article,
          tapis: {
            _id: this.subid,
          },
        };
      } else if (this.detailsElement.typeArticle == "autre") {
        product = {
          image: this.detailsElement.autre[0].image[0],
          label: this.detailsElement.label,
          productPrice: this.detailsElement.productPrice,
          type: this.detailsElement.typeArticle,
          quantite: parseInt(this.model.quantite),
          color: this.colorImg,
          productId: this.$router.history.current.query.id_article,
          autre: {
            _id: this.subid,
          },
        };
      }
      console.log("product", product);
      localStorage.setItem("ProductNumber", ProNum);
      localStorage.setItem("product" + ProNum, JSON.stringify(product));
      console.log(
        "object",
        JSON.parse(localStorage.getItem("product" + ProNum))
      );
      this.$toast.open({
        message: "Produit bien ajouté au Panier",
        type: "success",
      });
      for (var k = 1; k <= ProNum; k++) {
        TabThemes.push(localStorage.getItem("product" + k));
      }
      this.$store.commit("setbasket", TabThemes);
    },
  },
};
